// local imports
import { larkYellow, darkGrey, primaryColor } from '~/colors'
import { contentWidth } from '~/dims'
import React, {useState} from "react";

const link = {
    margin: 15,
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontWeight: '300',
    color: larkYellow,
}

export default {
    link: {
        ...link,
    },
    linkActive: {
        ...link,
        fontWeight: '999',
    },
    navRow: {
        paddingBottom: 10
    }
}



// WEBPACK FOOTER //
// ./src/views/Root/Nav/styles.js